/**
 * Shared Mutawatteen Outstanding broadcast constants.
 * Tenant allowlist must stay in sync with API `MUTTAVATTEEN_OUTSTANDING_BROADCAST_ENABLED_TENANT_IDS`.
 */

import { isTenantInOutstandingBroadcastAllowlist } from "./outstanding-broadcast-tenant-gate";

export const DEFAULT_MUTTAVATTEEN_OUTSTANDING_TEMPLATE_NAME =
  "muttavatteen_monthly_outstanding_reminder";
export const MUTTAVATTEEN_YEARLY_OUTSTANDING_TEMPLATE_NAME =
  "muttavatteen_yearly_outstanding_reminder";

export const MUTTAVATTEEN_OUTSTANDING_NOTIFY_HOLDER_ONLY = "holder_only";
export const DEFAULT_MUTTAVATTEEN_OUTSTANDING_MIN_PERCENT = 1;

export const MUTTAVATTEEN_OUTSTANDING_BROADCAST_ENABLED_TENANT_IDS: ReadonlySet<string> = new Set([
  "FP1",
  "JP1",
]);

/** True when Mutawatteen Outstanding mode should be shown / used for this tenant. */
export function isMuttavatteenOutstandingBroadcastEnabledForTenant(
  tenantId: string | null | undefined
): boolean {
  return isTenantInOutstandingBroadcastAllowlist(
    tenantId,
    MUTTAVATTEEN_OUTSTANDING_BROADCAST_ENABLED_TENANT_IDS
  );
}
